import { EntitySettings, useEntitySettings } from '@context/EntityContext'
import { usePublicDomainsReadContext } from '@context/PublicDomainsContext'
import {
  isOverrideLocaleForENorTR,
  overrideForZHToCNLanguage,
  useSessionLanguage,
} from '@context/SessionSettingsContext'

import { TickmillCompaniesEnum } from '@utils/companyName.utils'

import { Locale, OverrideLocaleForZHLanguage } from '@global/locale/Locale'

export const useHomePageUrl = (): string => {
  const { domains } = usePublicDomainsReadContext()
  const locale = useSessionLanguage()

  const [entity] = useEntitySettings()

  if (domains?.homePageUrl) {
    return domains.homePageUrl
  }

  if (isOverrideLocaleForENorTR(locale)) {
    return getHomePageByEntity(entity)
  }

  return getHomePageByLang(entity, locale)
}

export const useHomePageLink = (): string => {
  const locale = useSessionLanguage()

  const [entity] = useEntitySettings()

  if (isOverrideLocaleForENorTR(locale)) {
    return getHomePageByEntity(entity)
  }

  return getHomePageByLang(entity, locale)
}

const getHomePageByEntity = (entity: EntitySettings) => {
  switch (entity.entity) {
    case TickmillCompaniesEnum.TICKMILL_UK:
      return 'https://tickmill.com/uk'
    case TickmillCompaniesEnum.TICKMILL_EU:
      return 'https://tickmill.com/eu'
    case TickmillCompaniesEnum.GENERIC:
      if (window.location.hostname.endsWith('.com')) {
        return 'https://www.tickmill.com'
      }
      return 'https://www.tickmill.net'
    case TickmillCompaniesEnum.TICKMILL_PA:
    case TickmillCompaniesEnum.TICKMILL_SC:
    case TickmillCompaniesEnum.TICKMILL_AS:
      return 'https://www.tickmill.com'
    default:
      return 'https://www.tickmill.com'
  }
}

const getHomePageByLang = (
  entity: EntitySettings,
  locale: Locale | OverrideLocaleForZHLanguage
) => {
  const homePageUrl = getHomePageByEntity(entity)
  const zhToCNLanguage = overrideForZHToCNLanguage(locale)
  return `${homePageUrl}/${zhToCNLanguage}`
}
